import { render, staticRenderFns } from "./CatalogProposals.vue?vue&type=template&id=acb2f7b2"
import script from "./CatalogProposals.vue?vue&type=script&lang=js"
export * from "./CatalogProposals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports